module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpc.43b8cb4d4dd1ddfd184d10cdeecf04ba.png";